import styled from "styled-components";
import { devices } from "../../FormEnrollmentNew.styles";
import { BiCheck } from "react-icons/bi";

export const Container = styled.div`
  display: flex;
  flex: 0 1 100%;
`;

export const ProductCardContainer = styled.div<{isChecked: boolean}>`
  flex-grow: 1;
  border-radius: 12px;
  ${({ isChecked}) => (isChecked && (
      `outline: 3px solid var(--color-petrol);`
  ))}
`;

export const ProductCard = styled.div<{ isChecked: boolean, hasOffer?: boolean, hasBottomOffer?: boolean }>`
  padding: 16px;
  border-radius: ${({ hasOffer, hasBottomOffer }) => (hasOffer ? hasBottomOffer ? `0px 0px 0px 0px` : `0px 0px 12px 12px` : hasBottomOffer ? `12px 12px 0px 0px` :`12px`)};
  border: 1.6px solid #ccc;
  background: #F9F9F9;
  cursor: pointer;
  box-shadow: rgba(135, 135, 135, 0.15) 0px 2px 8px 0px;
  transition: all 0.4s ease-in-out;
/*    ${({ isChecked, hasOffer }) => (isChecked && !hasOffer && (
      `outline: 3px solid var(--color-petrol);`
  ))} */
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`;

export const TopContainerRight = styled.div`
  margin-left: 8px;
`;

export const DropdownIcon = styled.img<{ isOpen: boolean }>`
  transition: all 0.4s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  min-width: 34px;
  padding: 8px;
  margin-top: -8px;
  ${({ isOpen }) => (isOpen && "background-color:#E8F7F9; border-radius: 50%;")}
  &:hover {
    background-color:#E8F7F9; border-radius: 50%;
  ]
`;

export const TopContainerLeft = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

export const TitleContainer = styled.div`
  margin-left: 12px;
  margin-top: -3px;
`;

export const Title = styled.p`
  color: var(--color-coal);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 0px;
  line-height: 1.4;
`;

export const Teaser = styled.p`
  font-size:16px;
`;

export const ExtraPrice = styled.p` 
  font-size: 12px;
  font-weight: 500;
  text-align: right;
  margin-top: 4px;
  margin-bottom: 0px;
  display: inline;
  @media ${devices.tablet} {
      padding-left: 8px;
      display: block;
  }
`;


export const Input = styled.div<{ isChecked: boolean }>`
  border-radius: 7px;
  border: 1.6px solid #7B7B7A;
  background-color: ${({ isChecked }) => (isChecked ? `var(--color-coal)` : `#fff`)};
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const CheckedInput = styled(BiCheck)`
  font-size: 28px;
  color: #ffffff;
`;

export const InfoList = styled.ul<{ show: boolean }>`
  display: ${({ show }) => (show ? "block" : "none")};
  color: #7B7B7A;
  font-size: 16px;
  margin-top: 12px;
  list-style: none;
  padding-left: 0px;
  border-top: 0.8px solid #EEF0F3;
  padding-top: 12px;
`;

export const InfoItem = styled.li`
  position: relative;
  margin-bottom: 8px;
  padding-left: 16px;
  &::before {
      content: "•";
      color: var(--color-orange);
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
  }
`;

export const Price = styled.p`
  color: var(--color-coal);
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 0px;
  display: inline;
  span.offerPrice {
    padding: 4px 8px;
    border-radius: 8px;
    background-color: var(--color-orange-100);
  }
  span.salaryinsurance-price {
    font-weight: 500;
  }
  @media ${devices.tablet} {
      font-size: 16px; 
      display: block;
  }
`;

export const PriceDefinition = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const PriceContainer = styled.div`
  justify-content: end;
  width: 100%;
  text-align: right;
 /*  @media ${devices.tablet} {
      display: flex;
  } */
`;

export const OfferContainer = styled.div`
    border-radius: 12px 12px 0px 0px;
    color: #FFFFFF;
    font-size: 14px;
    background: #006571;
    display: flex;
    padding: 8px;
    /* justify-content: center; */
    justify-content: space-between;
    /* align-items: flex-start; */
    align-items: center;
`;

export const OfferLabel = styled.div`
    padding: 4px 7px;
    border-radius: 8px;
    background-color: var(--color-orange);
    color: rgb(255, 255, 255);
    font-size: 11px;
}
`;

export const ExtraOfferPrice = styled.div`
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 0px;
    font-style: italic;
    color: rgb(123, 123, 122);
`;


export const OfferText = styled.div`
    padding-left: 10px;
`;

export const OfferContainerDark = styled.div`
  border-radius: 0px 0px 12px 12px;
  color: #FFFFFF;
  font-size: 14px;
  background: var(--color-coal);
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: flex-start;
`;